import { inject, Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { map, Observable } from 'rxjs';

import { BaseApiService } from '@app/core/api/base-api.service';
import { AiProviderDto } from '@stores/ai-providers';

@Injectable({ providedIn: 'root' })
export class AiProvidersService {
  private readonly api = inject(BaseApiService);
  private readonly apiVersion = 'v1';
  private readonly resourcePath = `${this.apiVersion}/tenants`;

  getAiProviders(tenantUuid: string, page?: number, size?: number): Observable<AiProviderDto[]> {
    type ApiAiProvider = AiProviderDto;
    let params = new HttpParams();
    if (page && size) {
      params.set('page', String(page)).set('size', String(size));
    }
    return this.api
      .get<readonly ApiAiProvider[]>(`${this.resourcePath}/${tenantUuid}/aiProviders`, { params })
      .pipe(map((arr) => (Array.isArray(arr) ? arr : [])));
  }
}
